export enum AuthStatus {
  Allowed,
  NoAllowlist,
  None,
}
